// extracted by mini-css-extract-plugin
module.exports = {"AccountManagementToggle":"_2UI8unNt","label":"_15bk8px-"};